import CryptoJS from "crypto-js";
import { BaseUrl } from "../BaseUrl";
import { toastErrorr, toastSuccesss } from "../ToastMessage";
// import { toastErrorr, toastSuccesss } from "../ToastMessage";

export async function loginUser(dispatch, loginPayload) {

	const { userName, password, setloading, handleRollIdWiseDashboard, setLoginMsg } = loginPayload

	let myHeaders = new Headers();
	myHeaders.append("Content-Type", "text/plain");

	let raw = `grant_type=password&Username=${userName}&Password=${password}&ApplicationType=Web`

	const requestOptions = {
		method: 'POST',
		headers: myHeaders,
		body: raw,
	};

	try {
		setloading(true)
		dispatch({ type: 'REQUEST_LOGIN' });
		let response = await fetch(`${BaseUrl}/Token`, requestOptions)
		let data = await response.json();
		// console.log(data.Loginmessage);
		// toastSuccesss(data.Loginmessage)
		setLoginMsg({
			msg: data.Loginmessage,
			type: true
		})

		// console.log(data)

		if (data && data.access_token) {
			dispatch({ type: 'LOGIN_SUCCESS', payload: data });
			setloading(false)
			// toastSuccesss(data.Loginmessage)
			handleRollIdWiseDashboard(data)

			var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), 'RangaFulan09').toString();
			var ciphertextuserName = CryptoJS.AES.encrypt(JSON.stringify(userName), 'RangaFulan09userName').toString();
			var ciphertextpassword = CryptoJS.AES.encrypt(JSON.stringify(password), 'RangaFulan09password').toString();
			try {
				sessionStorage.setItem("Garden", ciphertext);
				sessionStorage.setItem("GardenuserName", ciphertextuserName);
				sessionStorage.setItem("Gardenpassword", ciphertextpassword);
				// toastSuccesss()
			} catch (error) {
				console.error("Error storing data in sessionStorage", error);
			}

			return data;
		} else {
			setloading(false)
			// toastErrorr(data.error)
			setLoginMsg({
				msg: 'Incorrect Username or Password !',
				type: false
			})
			dispatch({ type: 'LOGIN_ERROR', error: data.errors });
			console.log(data.errors);
			return;
		}
	}
	catch (error) {
		setloading(false)
		dispatch({ type: 'LOGIN_ERROR', error: error });
		// toastErrorr('Something went wrong !')
		setLoginMsg({
			msg: 'Incorrect Username or Password !',
			type: 'false'
		})
		console.log(error);
	}
}

export async function logout(dispatch) {
	dispatch({ type: 'LOGOUT' });
	sessionStorage.removeItem('Garden');
	localStorage.clear()
}
